import React from "react";
import Constants from "app_constants";
import Theme from "./theme";

const Pricing = () => {
  return (
    <Theme>
      {Constants.metaTag}

      <section class="section">
        <div className="container">
          <img
            src={require("assets/img/happy-people.png")}
            width="300"
            alt="Happy People"
          />

          <h4 className="title is-4">
            Our platform is %100 free for both job seekers and companies!
          </h4>
        </div>

        {/*<h4 className="title is-4" >Companies can publish the first job ad for free.</h4>

        <br />

        <PricingTable />*/}
      </section>
    </Theme>
  );
};

export default Pricing;
